import type { UpdateOrderRequest } from '@witmetrics/api-client';
import { strip } from '@witmetrics/utils/strings';
import type { OrderStatusId } from '@witmetrics/utils';
import { API } from '@/api';

export const classes = {
  dialog: 'w-[80vw] min-w-[250px] max-w-[550px] flex flex-col',
  body: 'grow pt-0',
  form: 'flex flex-col',
  input: 'w-full mb-8',
};

export function updateOrder(
  orderId: number,
  orderStatusId: OrderStatusId,
  externalRef: string,
  createdAt: string | null
) {
  let updates: UpdateOrderRequest = {
    orderStatusId,
    externalRef: strip(externalRef, true),
  };
  if (createdAt) updates.createdAt = createdAt;
  return API.Orders.updateOrder(orderId, updates);
}
